// extracted by mini-css-extract-plugin
export var actions = "nav-module--actions---b5l9";
export var bg = "nav-module--bg--7AsHg";
export var button = "nav-module--button--Cmu-G";
export var content = "nav-module--content--42M23";
export var social = "nav-module--social--y-kwm";